import React, { useContext, useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { useTranslation } from "react-i18next";
import { authContext } from "@/shared/model/authContext";
import { getSupportSession } from "@/shared/lib/supportSession";

function formatRemaining(ms: number): string {
    const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

/** Faixa fixa da sessão de suporte; ao fim dos 15 minutos volta sozinha à sessão do admin. */
export function SupportSessionBanner() {
    const { t } = useTranslation("common");
    const { isSupportSession, signOut } = useContext(authContext);
    const [session] = useState(() => getSupportSession());
    const [now, setNow] = useState(() => Date.now());

    const endsAt = session?.endsAt ?? 0;

    useEffect(() => {
        if (!isSupportSession || !endsAt) return;
        const timer = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(timer);
    }, [isSupportSession, endsAt]);

    useEffect(() => {
        if (isSupportSession && endsAt && now >= endsAt) {
            signOut();
        }
    }, [isSupportSession, endsAt, now, signOut]);

    if (!isSupportSession || !session) return null;

    return (
        <div role="status" className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 bg-yellow px-4 py-2 text-sm font-semibold text-night">
            <span className="flex items-center gap-2">
                <Eye size={16} aria-hidden />
                {t("supportSession.banner", { name: session.targetLabel })}
            </span>
            <span className="font-mono tabular-nums">{formatRemaining(endsAt - now)}</span>
            <button
                type="button"
                onClick={signOut}
                className="rounded bg-night px-3 py-1 text-xs font-bold uppercase tracking-wide text-yellow hover:opacity-90"
            >
                {t("supportSession.end")}
            </button>
        </div>
    );
}
